/* eslint-disable */
const defaultState = null;

export default function (state = defaultState, action) {
  switch (action.type) {
    case 'AUTH_PASSWORD_RECOVERY_SUCCESS':
      return true;

    case 'AUTH_PASSWORD_RECOVERY_RESET':
      return false;

    default:
      return state;
  }
}
